<template>
  <Teleport to="#modals">
    <RecruiterFreelancerModal
      :show="show"
      :on-cancel="() => $emit('cancel')"
      :on-confirm="onConfirm"
      :currency="currency"
      :title="$t('Edit candidate')"
      :name-disabled="true"
      :email-disabled="true"
      :initial-name="name"
      :initial-email="email"
      :initial-rates="rates"
      :initial-job-title="jobTitle"
      :initial-country="country"
      :initial-state="state"
      :initial-tags="tags"
      :initial-links="links"
      :initial-files="files"
      :error-text="$t('An error occurred while trying to edit candidate')"
      :save-button-text="$t('Save')"
      :save-button-text-while-working="$t('Saving')"
    />
  </Teleport>
</template>

<script setup lang="ts">
import { useMutation } from '@vue/apollo-composable'
import RecruiterFreelancerModal from '@/components/Contacts/RecruiterFreelancer/RecruiterFreelancerModal.vue'
import { UpdateRecruiterCandidateMutation } from '@/components/Contacts/RecruiterFreelancer/graphql/mutations'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import { Link } from '@/gql/graphql'
import { Name } from '@/components/Contacts/types'

const { mutate: mutateUpdateCandidate } = useMutation(UpdateRecruiterCandidateMutation, {
  clientId: 'publicApi',
})

defineEmits(['cancel'])

const props = defineProps<{
  id: string
  name: Name
  email: string
  currency: string
  rates: object
  jobTitle?: string
  country?: string
  state?: string
  tags: string[]
  links: Link[]
  files: any[]
  show: boolean
}>()

async function onConfirm(data) {
  await mutateUpdateCandidate({
    input: {
      id: props.id,
      jobTitle: data.jobTitle,
      country: data.country,
      state: data.state,
      currency: props.currency,
      hourlyRate: data.hourlyRate,
      dailyRate: data.dailyRate,
      monthlyRate: data.monthlyRate,
      tags: data.tags,
      links: data.links,
      files: data.files ?? [],
    },
  })
}
</script>
